<template>
  <!-- {{profile}} -->
  <div class="user-wrapper w-100">
    <profile-header></profile-header>
    <div class="user-content">
      <div class="responsive-container">
        <div class="my-auto" style="margin:auto;">
          <div class="row">
            <div class="col-md-12" v-if="show_msg && maintenance_msg != ''">
              <div
                class="msg-area-profile main-area  w-100 "
                style="white-space: pre-wrap"
              >
                {{ maintenance_msg }}
              </div>
            </div>
          </div>
        </div>

        <TopContacts />


        <Loader v-if="Object.keys(profile).length === 0" />

        <div class="my-auto w-100 main-area" v-else>
          <div class="profile-detail">
            <div
              class="profile-detail-block event-block"
              v-if="allEvents.length > 0"
              style="background-color:#ffffff"
            >
              <h2 class="event-title-full">イベント情報</h2>
              <div class="table-responsive">
                <b-card
                  no-body
                  class="overflow-hidden mb-2"
                  v-for="event in allEvents"
                  :key="event._id"
                >
                  <b-row no-gutters class="mobile">
                    <div class="container d-flex">
                      <b-col md="12">
                        <!-- <div class="box"> -->
                        <p class="eventdate">
                          {{
                            formatEventDate(
                              event.event_date.from,
                              event.event_date.to
                            )
                          }}
                          <!-- {{ formatDate(event.event_date.from, "YYYY-MM-DD") }}
                          {{ formatDate(event.event_date.from, "HH:mm") }}-{{
                            formatDate(event.event_date.to, "HH:mm")
                          }} -->
                        </p>
                        <!-- </div> -->
                      </b-col>
                    </div>
                    <div
                      class="container d-flex justify-content-between mobilecontainer align-items-end mb-2"
                      style="margin-top:-10px;"
                    >
                      <b-col xs="12" sm="6" lg="8">
                        <!-- <p class="event-name">KDDI・電通・三菱地所3社協働開催「大手伝統企業へのITエンジニア転職」を考える方へのオンライン説明会 -</p> -->
                        <p class="event-name">
                          {{ event.event_name }}
                        </p>
                      </b-col>
                      <!-- <b-col md="4" class="event-application-full">
                        <b-card-text>
                            <p class="application-title">
                            <strong>申込み期間</strong><br />
                            <span class="application-date"
                                >{{
                                formatDate(
                                    event.application_period.from,
                                    "YYYY-MM-DD HH:mm"
                                )
                                }}
                                ~
                                {{
                                formatDate(
                                    event.application_period.to,
                                    "YYYY-MM-DD HH:mm"
                                )
                                }}</span
                            >
                            </p>
                        </b-card-text>
                        </b-col> -->
                      <b-col
                        lg="4"
                        sm="6"
                        style="margin:auto;"
                        class="button-container"
                      >
                        <div class="eventbutton" style="float:right">
                          <button type="button" class="button eventlink mr-2">
                            <span
                              v-html="eventUrlify(event.lp_url)"
                              class="text-nowrap"
                            ></span>
                          </button>
                          <button
                            type="button"
                            :class="checkIfApplied(event)"
                            :disabled="checkToDisable(event)"
                            @click="showEventModal(event)"
                            style="color: #ffffff; border-radius: 4px;"
                          >
                            {{ checkApplied(event) }}
                          </button>
                        </div>
                      </b-col>
                    </div>
                    <div class="container d-flex">
                      <b-col sm="6">
                        <div class="eventbutton mobile-btn">
                          <button type="button" class="button eventlink">
                            <span
                              v-html="eventUrlify(event.lp_url)"
                              class="text-nowrap"
                            ></span>
                          </button>
                        </div>
                      </b-col>
                      <b-col sm="6">
                        <div
                          class="eventbutton mobile-btn"
                          style="margin-bottom: 10px;"
                        >
                          <button
                            type="button"
                            :class="checkIfApplied(event)"
                            :disabled="checkToDisable(event)"
                            @click="showEventModal(event)"
                            style="color: #ffffff; border-radius: 4px;"
                          >
                            {{ checkApplied(event) }}
                          </button>
                        </div>
                      </b-col>
                      <!-- <b-col sm="9">
                        <b-card-text class="event-application-mobile">
                            <span
                            style="margin-right:4px; font-weight:700"
                            class="mobile-title"
                            >申込み期間</span
                            >
                            <span class="mobile-app-date"
                            >{{
                                formatDate(
                                event.application_period.from,
                                "YYYY-MM-DD HH:mm"
                                )
                            }}
                            ~<br class="mobile-only" /><span
                                class="mobile-only-span"
                                >{{
                                formatDate(
                                    event.application_period.to,
                                    "YYYY-MM-DD HH:mm"
                                )
                                }}</span
                            ></span
                            >
                        </b-card-text>
                        </b-col> -->
                    </div>
                  </b-row>
                </b-card>
              </div>
            </div>
            <!-- ends profile-info-block -->
          </div>
          <!-- ends profile-detail -->
        </div>
        <!-- ends main-area -->
        <Loader v-if="!data.companies" :field="'companies'" />
        <div class="my-auto w-100 main-area main-area-sharing" v-else>
          <div class="profile-detail">
            <div class="profile-info-block">
              <div class="mobile-sharing-row">
                <form data-vv-scope="sharing">
                  <div class="edit-block">
                    <button
                      class="btn btn-secondary rounded btn-sm font-16 editBtn"
                      v-on:click.prevent="toggleEdit('sharing')"
                    >
                      編集
                    </button>
                  </div>
                  <h2 class="rg-title">登録企業の選択・解除</h2>
                  <div>
                    <table class="table">
                      <tbody>
                        <tr>
                          <!-- <th>登録先企業</th> -->
                          <td>
                            <span class="edit-txt">
                              <div class="col-lg-12 mb-30">
                                <div class="row">
                                  <div
                                    class="col-lg-6 col-md-6 companies"
                                    v-for="(company, index) in data.companies"
                                    v-bind:key="company._id"
                                  >
                                    <div
                                      :class="checkShared(company._id, false)"
                                    >
                                      <div class="form-check">
                                        <input
                                        type="checkbox"
                                        :id="company._id"
                                        :value="company._id"
                                        class="form-check-input"
                                        name="other_companies"
                                        v-model="profile.other_companies"
                                        disabled
                                      />
                                      <label
                                        v-b-toggle="'accordion-' + index"
                                        class="m-1 form-check-label"
                                        style="cursor: pointer"
                                      >
                                        {{ company.name }}
                                        <i
                                          class="fa fa-sort-down"
                                          aria-hidden="true"
                                          style="position: relative; top: -3px"
                                        ></i>
                                      </label>
                                      </div>
                                      <b-collapse
                                        v-bind:id="'accordion-' + index"
                                        accordion="my-accordion"
                                        role="tabpanel"
                                      >
                                        <b-card
                                          ><span
                                            v-html="
                                              urlify(company.short_description)
                                            "
                                          ></span
                                        ></b-card>
                                      </b-collapse>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </span>
                            <b-modal
                              size="xl"
                              ref="profileSharingModal"
                              hide-footer
                            >
                              <template #modal-header>
                                <!-- Emulate built in modal header close button action -->
                                <!-- <button type="button" class="close" aria-label="Close" v-on:click.prevent="cancel('sharing')">
                                      <span aria-hidden="true">&times;</span>
                                    </button> -->
                                <img
                                  src="../assets/close.png"
                                  v-on:click.prevent="cancel('sharing')"
                                  style="cursor:pointer;margin-top:5px"
                                />
                                <h5 class="sharingTitle">
                                  登録先企業の選択・解除
                                </h5>
                                <button
                                  data-v-bf1681ae=""
                                  title="保存"
                                  class="btn btn-secondary rounded btn-sm font-16 editBtn share"
                                  @click="openConfirmModal"
                                >
                                  保存
                                </button>
                              </template>
                              <div
                                class="select_all d-flex justify-content-center align-items-center"
                              >
                                <input
                                  class="custom-checkbox mr-3"
                                  type="checkbox"
                                  v-model="selectAllCompaniesModel"
                                  id="select_all"
                                  name="select_all"
                                />
                                <label
                                  class="form-check-label font-18"
                                  for="select_all"
                                  style="padding-top: 3px"
                                >
                                  すべて選択（全{{ data.companies.length }}社）
                                </label>
                              </div>
                              <div
                                class="d-flex px-3 py-2 flex-wrap align-items-start"
                                style="overflow-y:scroll;max-height:80vh"
                              >
                                <div class="row px-3 py-2">
                                  <div
                                    :class="checkShared(company._id)"
                                    v-for="(company, index) in data.companies"
                                    v-bind:key="company._id"
                                  >
                                    <div
                                      class="d-flex justify-content-between font-16"
                                    >
                                      <div class="d-flex align-items-center">
                                        <div
                                          style="height: 20px; width: 20px;"
                                          class="mr-3"
                                        >
                                          <input
                                            class="custom-checkbox"
                                            type="checkbox"
                                            :id="company._id"
                                            :value="company._id"
                                            name="other_companies"
                                            v-model="profile.other_companies"
                                          />
                                        </div>
                                        <label
                                          class="form-check-label "
                                          :for="company._id"
                                          style="padding-top: 3px;"
                                          v-b-toggle="`accordino0_${index}`"
                                        >
                                          {{ company.name }}
                                        </label>
                                      </div>
                                      <div></div>
                                    </div>
                                    <div>
                                      <b-collapse
                                        class="py-1"
                                        v-bind:id="`accordino0_${index}`"
                                        accordion="my-accordion"
                                        role="tabpanel"
                                      >
                                        <b-card>
                                          <span
                                            style="color: black !important"
                                            v-html="
                                              urlify(company.short_description)
                                            "
                                          >
                                          </span>
                                        </b-card>
                                      </b-collapse>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-modal>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
            </div>
            <!-- ends profile-info-block -->
          </div>
          <!-- ends profile-detail -->
        </div>

        <!-- ends main-area -->
      </div>
    </div>
    <!-- ends user-content -->

    <!-- event modal -->
    <b-modal id="modal1" ref="eventModal" size="lg" hide-footer>
      <template #modal-header>
        <img
          src="../assets/close.png"
          v-on:click.prevent="cancel('event')"
          style="cursor:pointer;margin-top:5px"
        />
        <h5 class="sharingTitle">
          イベント申込み
        </h5>
        <button
          data-v-bf1681ae=""
          title="申込みに進む"
          class="btn btn-secondary rounded btn-sm font-16 editBtn event-edit"
          :disabled="!checkIfCompany() || eventSubmit"
          @click="openConfirmModal('event')"
        >
         申込みに進む
        </button>
      </template>
      <p class="event-modal-title">
        イベント開催企業へのキャリア登録が必要です。<br />以下から1社以上を、登録企業として選択してください。
      </p>
      <div
        class="d-flex px-3 py-2 flex-wrap flex-column align-items-start align-content-center"
      >
        <div class="col-md-6 p-0">
          <div
            class="col border py-1"
            v-for="(company, index) in event.companies"
            v-bind:key="company._id"
          >
            <div class="d-flex justify-content-between font-16">
              <div class="d-flex align-items-center">
                <div style="height: 20px; width: 20px;" class="mr-3">
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    :id="company._id"
                    :value="company._id"
                    name="other_companies"
                    v-model="profile.other_companies"
                  />
                </div>
                <label
                  class="form-check-label"
                  :for="company._id"
                  style="padding-top: 3px;"
                >
                  {{ company.name }}
                </label>
              </div>
              <div>
                <i
                  v-b-toggle="`accordino0_${index}`"
                  class="fa fa-chevron-down"
                  aria-hidden="true"
                  style="height: 100%"
                ></i>
              </div>
            </div>
            <div>
              <b-collapse
                class="py-1"
                v-bind:id="`accordino0_${index}`"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card>
                  <span v-html="urlify(company.short_description)"> </span>
                </b-card>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <div :class="checkClass" @click="hideConfirm" v-if="showSharingConfirm">
      <div
        class="swal-modal custom-swal2"
        role="dialogue"
        aria-modal="true"
        style="background:#DFEBFF; max-width:600px;padding-top:80px;"
      >
        <!-- <div class="swal-title">注意事項</div> -->
        <div class="swal-content" style="margin-bottom:50px;padding: 0 36px;">
          <p
            style="font-size:24px;text-align:center;font-weight:700;color:#DD3847"
          >
            ご自身の在籍企業など、情報を公開したくない<br/>企業が含まれていないか十分注意してください。
          </p>
          <ul class="notice-list" style="">
            <li>
              <!-- <p style="text-align:center;margin-bottom:1px"> -->
                企業を選択した場合、現在ご登録のプロフィール情報が、企業へ公開されます。
              <!-- </p> -->
            </li>
            <li>
              <!-- <p style="text-align:center;margin-bottom:1px"> -->
                登録企業は、ユーザーが他に登録している企業を確認することはできません。
              <!-- </p> -->
            </li>
            <li>
              <!-- <p style="text-align:center;"> -->
                ユーザーの承諾無しに、登録企業以外へ情報が公開されることはありません。
              <!-- </p> -->
            </li>
          </ul>
        </div>
        <div
          class="swal-content full-footer"
          style="padding:0px !important; text-align:center;margin-bottom:10px;"
        >
          <div
            class="swal-footer d-flex justify-content-center custom-modal-footer full"
          >
            <button
              class="btn text-white btn-sm rounded  mx-1 font-14 font-bold custom-blue-bg w-230"
              style="width:260px !important;font-size:18px; font-weight: 600;"
              @click="hideConfirm"
            >
              キャンセル
            </button>
            <button
              class="btn text-white btn-sm rounded  mx-2 font-8 text-center custom-red-bg w-230"
              style="width:260px !important; font-size:8px;font-weight: 600"
              @click="saveFunc"
            >
              <span v-if="isEventEdit">注意事項に同意してキャリア登録し</span>
              <span v-else>注意事項に同意して</span><br />
              <span class="font-bold font-14" style="font-size: 18px">
                <span v-if="isEventEdit">イベントに申込む</span>
                <span v-else>登録企業を更新する</span>
              </span>
            </button>
          </div>
        </div>
        <div class="swal-footer mobile-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm custom-red-bg"
              style="border-radius:3px"
              @click="saveFunc"
            >
              <span style="font-size:8px" v-if="isEventEdit">注意事項に同意してキャリア登録し</span>
              <span v-else style="font-size:8px" >注意事項に同意して</span><br/>

              <span v-if="isEventEdit" style="font-weight: bold;"
                >イベントに申込む</span
              >
              <span v-else style="font-weight: bold;">登録企業を更新する</span>
            </button>
            <div class="swal-button__loader">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--cancel custom-blue-bg"
              @click="hideConfirm"
              style="font-weight: bold;"
            >
              キャンセル
            </button>
            <div class="swal-button__loader">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Component -->
    <Unsubscribe />
    <Footer />
  </div>
  <!-- ends user-wrapper -->
</template>
<script>
/* eslint-disable */
import ProfileHeader from "@/components/header.vue";
import TopContacts from "./ContactList/TopContacts.vue";
import Api from "@/config/api";
// eslint-disable-next-line
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert";
import Footer from "./Footer.vue";
import Unsubscribe from "./Unsubscribe.vue";
import logo from "../assets/Group300.png";
import Loader from "./Loader.vue";
export default {
  components: {
    ProfileHeader,
    Footer,
    Unsubscribe,
    Loader,
    TopContacts
  },
  data() {
    return {
      data: {},
      events: [],
      isEvents: false,
      event: {},
      server_errors: {},
      selectedCursor: "pointer",
      tempSharingData: {},
      maintenance_msg: "",
      show_msg: false,
      selectAllCompaniesModel: false,
      //agreementcheck: false,
      eventSubmit: false,
      isSharingEdit: true,
      isEventEdit: false,
      showSharingConfirm: false,
    };
  },
  watch: {
    // eslint-disable-next-line
    selectAllCompaniesModel(check) {
      if (check) this.selectAllCompanies();
      else this.unselectAllcompanies();
    },
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      allEvents: "getAllEvents",
      companies: "getCompanies",
      // priorityCompanies: "getPriorityCompanies",
    }),
    checkClass() {
      if (this.showSharingConfirm) {
        return "swal-overlay swal-overlay--show-modal";
      } else {
        return "swal-overlay";
      }
    },
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
      setAllEvents: "setAllEvents",
      // loadPriorityCompanies: "loadPriorityCompanies",
      companiesList: "companiesList",
    }),
    openConfirmModal(group) {
      if (group == "event") this.isEventEdit = true;
      this.showSharingConfirm = true;
    },
    hideConfirm() {
      this.showSharingConfirm = false;
    },
    checkShared(x, isEdit = true) {
      if (!isEdit) {
        return "";
      }
      if (this.profile.other_companies.includes(x)) {
        return "col-lg-6 col-md-6 border py-1 shared";
      } else {
        return "col-lg-6 col-md-6 border py-1";
      }
    },
    redirect(link) {
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "http://" + link;
      }
      window.open(link, "_blank");
    },
    formatDate(date, format = "YYYY-MM-DD") {
      // console.log(date);
      const options = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const options2 = {
        hour: "numeric",
        minute: "numeric",
      };
      const finalDate = moment(date)
        .utc()
        .toDate();
      let japaneseDate = finalDate.toLocaleDateString("ja-JP", options);
      let japaneseTime = finalDate.toLocaleTimeString("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      });
      return moment(date)
        .utc()
        .format(format);
    },
    formatEventDate(eventDateFrom, eventDateTo, locale = "ja-JP") {
      // const dateFormatOptions = {
      //   month: "numeric",
      //   day: "numeric",
      //   weekday: "short",
      // };
      // const timeFormatOptions = {
      //   hour: "numeric",
      //   minute: "numeric",
      // };
        
      const formattedDateFrom = moment(eventDateFrom).locale("ja-JP").utc().format('M/D(ddd)');
      // console.log(eventDateFrom, formattedDateFrom);
      // // const formattedDateFrom1 = fromDate.toLocaleDateString(
      // //   locale,
      // //   dateFormatOptions
      // // );
      // // console.log(formattedDateFrom1);
      const formattedTimeFrom = moment(eventDateFrom)
        .utc()
        .format("HH:mm");
      const formattedTimeTo = moment(eventDateTo)
        .utc()
        .format("HH:mm");
      const displayString = `${formattedDateFrom} (${formattedTimeFrom}~${formattedTimeTo})`;
      return displayString;
    },

    eventUrlify(link) {
      var urlRegex = /(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
      return link.replace(urlRegex, function(url) {
        let checkLinkType =
          url.includes("http") || url.includes("http") ? true : false;
        if (checkLinkType) {
          return (
            '<a href="' +
            url +
            '" target="_blank" style="text-decoration:none;color:#006C6B">' +
            "詳細はこちら" +
            "</a>"
          );
        } else {
          return (
            '<a href="https://' +
            url +
            '" target="_blank" style="text-decoration:none;color:#006C6B">' +
            "詳細はこちら" +
            "</a>"
          );
        }
      });
    },
    checkIfApplied(event) {
      if (this.profile.events.includes(event._id)) {
        return "button applied";
      } else if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
        event.status.title == "Closed" ||
        moment(new Date()).format() <
          moment(event.application_period.from)
            .utc()
            .format()
      ) {
        return "button apply closed";
      } else if (event.is_test_event) {
        return "button apply test";
      } else {
        return "button apply valid";
      }
      // return false;
    },
    checkApplied(id) {
      if (this.profile.events.includes(id._id)) {
        return "申込み済";
      } else if (id.status.title === "Closed") {
        return "受付終了";
      } else {
        return "申込む";
      }
    },
    checkToDisable(event) {
      if (
        moment(event.application_period.to)
          .utc()
          .format() < moment(new Date()).format() ||
        this.profile.events.includes(event._id)
      ) {
        return true;
      } else if (
        moment(new Date()).format() <
        moment(event.application_period.from)
          .utc()
          .format()
      ) {
        return true;
      } else if (event.status.title == "Closed") {
        return true;
      }
      return false;
    },
    checkIfCompany() {
      let companies = [];
      if (JSON.stringify(this.event) != "{}") {
        companies = this.event.companies.map((item) => {
          return item._id;
        });
      }
      const found = companies.some((c) =>
        this.profile.other_companies.includes(c)
      );
      return found;
    },

    hasError(field, scope = null) {
      return (
        field in this.server_errors || this.errors.first(`${scope}.${field}`)
      );
    },
    getErrorMessage(field, scope = null) {
      if (field in this.server_errors) return this.server_errors[field].msg;
      else if (this.errors.first(`${scope}.${field}`)) {
        return this.errors.first(`${scope}.${field}`);
      }
      return null;
    },
    getStatus(id) {
      if (this.data.status) {
        const result = this.data.status.find(({ _id }) => _id === id);
        if (result) return result.title;
      }
      return "";
    },
    async saveEvent() {
      try {
        let data = {
          event_id: this.event._id,
          other_companies: this.profile.other_companies,
        };
        const token = await this.$auth.getToken();
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        this.eventSubmit = true;
        let user = await this.axios({
          method: "post",
          data,
          url: Api.url(Api.endpoints.event),
          headers: headers,
        });
        this.profile.events = user.data.data.events;
        // this.profile.other_companies = user.data.data.other_companies;
        this.$refs.eventModal.hide();
        this.showSharingConfirm = false;
        this.eventSubmit = false;
        let content = document.createElement("span");
        content.innerHTML = `<p style="font-weight:bold">イベント申込みが完了しました。</p>`;
        await swal({
          title: "",
          content: content,
          className: "custom-swal4",
          icon: logo,
          buttons: {
            ok: "OK",
          },
        });
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.status === 403 &&
          error.response.data.data
        ) {
          swal("", error.response.data.data.error_description, "error");
        } else if (
          (error.response && error.response.status === 503) ||
          (error.response && error.response.status === 401)
        ) {
          this.$router.push({ name: "Logout" });
        } else {
          swal("", "Something Went Wrong", "error");
        }
        this.showSharingConfirm = false;
        this.$refs.eventModal.hide();
      }
      this.isEventEdit = false;
    },
    async confirmSave() {
      let res = await swal({
        title: "入力情報を更新しますか？",
        text: `更新すると、最終更新日とともに登録先企業への表示が変更されます。\n また、履歴書や職務経歴書をアップロードまたは更新した場合、登録先企業全てに同じ内容が公開されます。`,
        icon: "warning",
        className: "custom-swal",
        closeOnClickOutside: false,
        buttons: {
          cancel: "キャンセル",
          ok: {
            text: "更新する",
            value: true,
            visible: true,
            closeModal: false,
          },
        },
      });
      return res;
    },
    saveFunc() {
      if (this.isEventEdit) {
        this.saveEvent();
      } else {
        this.saveSharing();
      }
    },
    saveSharing(url) {
      this.save(
        {
          other_companies: this.profile.other_companies,
        },
        "sharing"
      );
      this.showSharingConfirm = false;
      this.$refs.profileSharingModal.hide();
    },
    async save(data, url) {
      const check = await this.$validator.validateAll(url);
      if (check) {
        try {
          const token = await this.$auth.getToken();
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          await this.axios({
            method: "post",
            data,
            url: Api.url(Api.endpoints[url]),
            headers: headers,
          });
          if (url === "sharing") {
            //this.agreementcheck = false;
            this.isSharingEdit = true;
            let content = document.createElement("span");
            content.innerHTML = `<p style="font-weight:bold">登録企業を更新しました。</p>`;
            await swal({
              title: "",
              content: content,
              className: "custom-swal4",
              icon: logo,
              buttons: {
                ok: "OK",
              },
            });
            // swal("", "登録企業を更新しました。", "success");
          }
          this.clearErrors();
          return true;
        } catch (error) {
          if (error && error.response && error.response.status === 422) {
            this.server_errors = error.response.data;
          } else if (
            (error.response && error.response.status === 503) ||
            (error.response && error.response.status === 401)
          ) {
            this.$router.push({ name: "Logout" });
          } else {
            swal("", "Something Went Wrong", "error");
          }
          return false;
        } finally {
          swal.close();
        }
      } else {
        swal.close();
      }
    },
    clearErrors() {
      // clear errors
      this.errors.clear();
      this.server_errors = {};
    },
    clearServerError(name) {
      // clear server error of resume on file change
      const { [name]: exclude, ...newServerError } = this.server_errors;
      this.server_errors = { ...newServerError };
    },
    showEventModal(event) {
      this.event = event;
      this.$refs.eventModal.show();
      this.tempEvents = this.profile.events;
      this.tempSharingData.other_companies = this.profile.other_companies;
    },
    toggleEdit(group) {
      this.isSharingEdit = false;
      this.$refs.profileSharingModal.show();
      this.isEventEdit = false;
      this.tempSharingData.other_companies = this.profile.other_companies;
    },
    cancel(group) {
      if (group === "event") {
        this.$refs.eventModal.hide();
        this.profile.other_companies = this.tempSharingData.other_companies;
      } else {
        this.isSharingEdit = true;
        this.$refs.profileSharingModal.hide();
        this.profile.other_companies = this.tempSharingData.other_companies;
        //this.agreementcheck = false;
      }
      this.clearErrors();
    },
    selectAllCompanies() {
      this.profile.other_companies = this.data.companies.map(
        (company) => company._id
      );
    },
    unselectAllcompanies() {
      this.profile.other_companies = [];
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
    urlify(description) {
      var urlRegex = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w\-]*)?(\?[^\s]*)?/gi;
      return description.replace(urlRegex, function(url) {
        let checkLinkType =
          url.includes("http") || url.includes("http") ? true : false;
        if (checkLinkType)
          return '<a href="' + url + '" target="_blank">' + url + "</a>";
        else
          return (
            '<a href="https://' + url + '" target="_blank">' + url + "</a>"
          );
      });
    },
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: "get",
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;
          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = "";
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = "";
      }
    },
  },
  async mounted() {
    this.checkMaintenaceMsg();
  },
  async created() {
    this.scrollToTop();
    // console.log(await this.$auth.isAuthenticated());
    Object.keys(this.profile).length === 0 && (await this.setProfile());
    // await this.setProfile();
    await this.setAllEvents();
    // console.log(this.profile.events);
    // await this.loadPriorityCompanies();

    this.companies && !this.companies.length && (await this.companiesList());
    this.data = { companies: this.companies };
    this.$nextTick(()=>{
      if(this.$route.query.openCompanyShare === 'true'){
        this.toggleEdit('sharing')
      } 
    })
    // try {
    //   const token = await this.$auth.getToken();
    //   const response = await this.axios({
    //     method: "get",
    //     url: Api.url(`${Api.endpoints.companies}`),
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   });
    //   this.data = response.data.data;
    // } catch (error) {
    //   console.log(error);
    //   this.$router.push({ name: "Logout" });
    // }
  },
};
</script>
<style scoped>
.custom-red-bg {
  background-color: #dd3847 !important;
}

.mobile-footer {
  display: none;
}

.event-modal-title {
  margin-top: 60px;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
}
.notice-list {
  font-weight: bold;
  font-size: 13px;
  /* list-style-type: none; */
}

br.mobile-only {
  display: none;
}
.responsive-container {
  width: 100%;
  max-width: 1140px;
  margin-left: auto;
  margin-right: auto;
}
.modal-header {
  padding-left: 35px;
  padding-right: 35px;
}
.modal-header .close {
  padding: 0px;
  margin: 0px;
}
.rg-title {
  font-size: 24px;
  font-weight: 700 !important;
}
.main-area-sharing {
  margin-top: 10px !important;
}
.select_all_mobile {
  display: none;
}
.swal-footer {
  text-align: center !important;
}
.event-application-full {
  display: inline-block;
}
.event-application-mobile {
  display: none;
}
.shared {
  background: #006c6b;
  color: #ffff;
}
.shared.card-body {
  color: black;
}

.profile-info-block .edit-block {
  right: 54px;
  top: 50px;
}
.eventlink {
  padding: 0;
  border: 1px solid #006c6b;
  color: #000000;
  background: #ffffff;
  width: 143px;
  height: 50px;
  text-align: center;
  font-size: 16px;
  font-size: 17px;
  border-radius: 4px;
  font-weight: 500;
}
.eventlink a {
  color: #006c6b;
}
.applied {
  background: #f8be57;
  border-radius: 11px;
  border: #ffffff;
  width: 143px;
  height: 50px;
  text-align: center;
  font-size: 16px;
  color: #000000 !important;
}

.applied:disabled {
  opacity: 1;
  color: #000000 !important;
}

.test {
  background: #219653;
  border-radius: 11px;
  border: #ffffff;
  width: 143px;
  height: 50px;
  font-size: 16px;
  text-align: center;
  color: #ffffff !important;
}

.test:disabled {
  opacity: 1;
}

.valid {
  background: #006c6b;
  border-radius: 11px;
  border: #ffffff;
  width: 143px;
  height: 50px;
  font-size: 16px;
  text-align: center;
  color: #ffffff !important;
}

.valid:disabled {
  opacity: 1;
  color: #000000 !important;
}

.closed {
  background: #d9d9d9;
  border-radius: 11px;
  border: #ffffff;
  width: 143px;
  font-size: 16px;
  height: 50px;
  text-align: center;
  color: #000000 !important;
}
.eventdate {
  margin-top: 16px;
}
.closed:disabled {
  opacity: 1;
  color: #000000 !important;
}
.event-modal-text {
  font-size: 20px;
  line-height: 38px;
}
.event-name,
.application-title {
  font-family: "Yu Gothic";
  font-weight: 800;
  font-size: 18px;
  margin-left: 8px;
  /* cursor: pointer; */
}
.eventdate,
.application-date {
  font-size: 16px;
  font-weight: 400;
  font-family: "Yu Gothic";
}

.eventdate {
  border: 1px solid black;
  padding: 2px;
  width: 200px;
  text-align: center;
}

.mobilecontainer {
  margin-bottom: 10px !important;
}
.event-modal-list {
  font-size: 19px;
}

.btn-first {
  font-size: 13px;
}
.btn-second {
  font-size: 16px;
}
table .phone {
  display: none;
}

.eventbutton.mobile-btn {
  display: none;
}

table .fixed {
  table-layout: fixed;
  width: 100%;
  word-break: break-word;
}

table.event th {
  vertical-align: top;
}
table.event td {
  vertical-align: middle;
}

table.event td:nth-of-type(1) {
  width: 10%;
}
table.event td:nth-of-type(2) {
  width: 35%;
}
table.event td:nth-of-type(3) {
  width: 24.5%;
}
table.event td:nth-of-type(4) {
  width: 8.5%;
}
table.event td:nth-of-type(5) {
  width: 8.5%;
}

@media only screen and (device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) {
  /* CSS rules specific to iPad Mini */
  .eventbutton.mobile-btn{
    display: none !important;
  }
  .eventbutton{
    display: block !important;
  }
  .button-container{
    display: block !important;
  }
}

@media (max-width: 768px) {
  .responsive-container {
    width: 100%;
    max-width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .event-application-full {
    display: none;
  }
  .event-application-mobile {
    /* margin-top:10px; */
    float: right;
    display: block;
    /* margin-right: -15px; */
    /* margin-left: 12px; */
    /* margin-right: 5px; */
    font-size: 15px;
    margin-left: -80px;
  }

  .event-modal-title {
    margin-top: 60px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
  }
  .notice-list {
    font-weight: bold;
    font-size: 10px;
    /* list-style-type: none; */
    margin-left: -25px;
  }
  .swal-modal .swal-content {
    padding: 0 20px !important;
  }

  .profile-info-block .edit-block {
    right: 32px !important;
    top: 40px !important;
  }
  .mobile-sharing-row {
    box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.1);
  }
  .rg-title {
    margin-left: 15px;
    font-size: 16px;
    font-weight: 700;
    padding-top:20px;
  }
  .companies {
    margin-left: 15px;
  }
  .main-area-sharing {
    margin-top: -50px !important;
  }

  .eventbutton.mobile-btn {
    display: block;
  }
  .button-container {
    display: none;
  }
  .eventbutton {
    display: none;
  }
  .mobilecontainer {
    margin-top: 0px !important;
  }
}
/* @media(max-width:991px){
  .profile-info-block .edit-block {
    right:45px; 
    top:40px;
  }
  .mobile-sharing-row{
    box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.10);
  }
  .rg-title{
    margin-left:15px;
  }
  .companies{
    margin-left:15px;
  }
} */
@media only screen and (max-width: 912px) and (min-width: 768px) {
  /* CSS apply on width between 768 and 912px */
  .event-application-full {
    display: none;
  }
  .event-application-mobile {
    float: right;
    display: block;
    /* margin-right: -15px; */
    /* margin-left: 12px; */
    /* margin-right: 5px; */
    font-size: 15px;
    margin-left: -80px;
  }
}

@media (max-width: 530px) {
  .main-area {
    box-shadow: none;
  }
  br.mobile-only {
    display: block;
  }
  .mobile-only-span {
    float: right;
    margin-right: 12px;
  }
  .event-block {
    /* border-top:1px solid #d9e6ed !important; */
    border: none;
  }
  .mobile {
    margin-left: -20px;
  }
  .mobilecontainer {
    margin-top: 0px !important;
  }

  .button.apply {
    width: 60px;
  }
  .event-application-full {
    display: none;
  }
  .event-application-mobile {
    float: right;
    display: block;
    margin-right: -15px;
    /* margin-left: 12px; */
    /* margin-right: 5px; */
    font-size: 14px;
    margin-left: -80px;
  }
  /* .eventbutton {
      margin-right: -16px;
    } */

  .applied {
    width: 100%;
    background: #f8be57;
    border-radius: 8px;
    height: 35px;
    font-size: 12px;
    /* margin-left:10px; */
    text-align: center;
  }
  .closed {
    width: 100% !important;
    background: #d9d9d9;
    border-radius: 8px;
    height: 35px;
    font-size: 12px;
    /* margin-left:10px; */
    text-align: center;
    color: #000000 !important;
  }
  .test {
    width: 100% !important;
    background: #219653;
    border-radius: 8px;
    border: #ffffff;
    height: 35px;
    font-size: 12px;
    /* margin-left:10px; */
    text-align: center;
    color: #ffffff !important;
  }
  .valid {
    width: 100% !important;
    background: #006c6b;
    border-radius: 8px;
    border: #ffffff;
    height: 35px;
    font-size: 12px;
    /* margin-left:10px; */
    text-align: center;
    color: #ffffff !important;
  }
  .event-name {
    font-size: 14px;
    line-height: 14px;
    font-weight: 700; 
    margin-left: 0px !important;
  }
  .eventlink {
    width: 100% !important;
    padding: 0;
    border: 1px solid #dcdcdc;
    color: #000000;
    background: #ffffff;
    height: 35px;
    width: 60px;
    font-size: 12px;
  }
  .event-name,
  .application-title {
    font-size: 14px;
  }
  .application-date {
    font-size: 8px;
  }
  .eventdate {
    font-size: 14px;
  }
  .eventdate {
    border: 1px solid black;
    padding: 2px;
    width: 180px;
  }
  .btn-first {
    font-size: 10px;
  }
  .btn-second {
    font-size: 12px;
  }
  .event-modal-text {
    font-size: 15px;
    line-height: 20px;
  }

  .event-modal-list {
    font-size: 12px;
  }

  table.event thead {
    display: none;
  }

  .event,
  .event tbody,
  .event tr,
  .event td {
    display: block;
    width: 100%;
  }

  .event tr {
    margin-bottom: 15px;
  }
  table.event td:nth-of-type(1) {
    width: 100%;
  }
  table.event td:nth-of-type(2) {
    width: 100%;
  }
  table.event td:nth-of-type(3) {
    width: 100%;
  }
  table.event td:nth-of-type(4) {
    width: 100%;
  }
  table.event td:nth-of-type(5) {
    width: 100%;
  }
  table.event td:nth-of-type(6) {
    width: 100%;
  }

  .event td {
    text-align: center;
    padding-left: 40%;
    position: relative;
  }

  .event td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 40%;
    padding-left: 10px;
    font-size: 15px;
    font-weight: bold;
  }

  table.event button {
    width: 100%;
  }
}
/deep/ #modal1 > .modal-dialog > .modal-content > .modal-header {
  background: #ffffff;
}

/deep/ #modal1 > .modal-dialog > .modal-content {
  min-height: 500px;
  max-height: 100%;
}
@media only screen and (max-width: 992px) {
  .enrolled-date {
    flex-wrap: wrap;
  }
  .enrolled-date span {
    justify-content: center;
    flex-basis: 100%;
  }
}

.flex-basis-100 {
  flex-basis: 100%;
}

.enrolled-date select {
  padding-right: 0.75rem !important;
}
.enrolled-date label {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-size: 15px;
}

.enrolled-date span {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-size: 20px;
  font-weight: bold;
}

.disable-select {
  background-image: none !important;
}

.disable-btn {
  color: gray;
}

.notice-txt {
  font-size: 14px;
  font-weight: 400;
  color: #89969f;
}
.notice-txt ol {
  font-size: 12px;
}
/* .site-title-custom1 {
  text-align: center;
  padding-top: 30px;
} */
.psmall {
  font-size: 0.875rem;
}
.is-valid {
  background-image: none;
}

.is-invalid {
  background-image: none !important;
}
.msg-area-profile {
  padding: 15px 15px;
  position: relative;
  display: table;
  margin: 0 auto;
  margin-bottom: 10px;
  border-radius: 0px;
  border: 1px solid #cc0000;
  color: #cc0000;
  margin-top: -2rem;
}
.delete-btn {
  margin-left: 10px;
  color: #fff !important;
  line-height: 24px;
}
.v-center {
  display: flex;
  align-items: center;
}
.w-fit-content {
  width: fit-content;
}

.profile-section {
  padding-left: 30px;
  margin-right: 55px;
}

@media (max-width: 767px) {
  .profile-section {
    padding-left: 0;
  }

  .editBtn {
    width: 100px !important;
    height: 40px !important;
  }

  .editBtn,
  .cancelBtn {
    padding-top: 3px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .event-cancelBtn {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

.editBtn {
  width: 143px;
  height: 50px;
  background: #006c6b;
  color: white;
  border: #227744;
  font-weight: bold;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 400;
  margin-right: 13px;
}

.editBtn:hover {
  background: #1a5b34;
}



.saveBtn {
  background: #ff0000;
  color: white;
  border: #ff0000;
  font-weight: bold;
}
.saveBtn:hover {
  background: #b70202;
}

.font-18 {
  font-size: 18px !important;
}

.font-16 {
  font-size: 16px !important;
}

.font-12 {
  font-size: 12px !important;
}

.keepBtn {
  background: #ff0000;
  color: white;
}

.keepBtn:hover {
  background: #bb0101;
  color: white;
}

.cancelBtn {
  background: #666666;
  color: white;
}

.cancelBtn:hover {
  background: #464646;
  color: white;
}

.event-cancelBtn {
  background: #e6e6e6;
  color: black;
}

>>> .sharingTitle {
  margin-top: 5px;
  color: black;
  font-weight: 600;
  margin-left:80px;
}

>>> .custom-checkbox {
  width: 20px;
  height: 20px;
}

>>> .custom-modal-footer > button {
  min-width: 150px;
}

@media (max-width: 767px) {
  .stickyFooter > div,
  >>> .custom-modal-footer {
    flex-direction: column !important;
  }

  .stickyFooter > div > button:nth-child(1),
  >>> .custom-modal-footer > button:nth-child(1) {
    margin-bottom: 0.5rem !important;
  }

  .editBtn.share {
    width: 20% !important;
  }

  .editBtn.event-edit {
    width: 20% !important;
    font-size:12px !important;
    white-space: normal;
  }
}

@media (min-width: 768px) {
  >>> .modal-lg,
  >>> .modal-xl {
    max-width: 800px !important;
  }
}

@media (min-width: 1200px) {
  >>> .modal-xl {
    max-width: 1140px !important;
  }
}

.profile-detail-block h2 {
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 30px;
}

.profile-detail-block table thead th {
  white-space: nowrap;
}

.profile-detail-block table thead th,
.profile-detail-block table thead td {
  font-size: 16px !important;
}

.event body td {
  vertical-align: middle !important;
}

.event td a {
  text-decoration: none !important;
}

.profile-detail-block .table-bordered td,
.profile-detail-block .table-bordered th {
  border-color: #b3b3b3 !important;
}

.profile-detail-block table thead th {
  background: #ebedee !important;
}

@media (max-width: 550px) {
  >>> .sharingTitle {
    font-size: 18px;
    font-weight: 700;
    margin-left: 0px;
  }
  br.mobile-only {
    display: block;
  }
  .mobile-only-span {
    float: right;
    margin-right: 12px;
  }
  .mobile-footer {
    display: block;
  }
  .full-footer {
    display: none;
  }
  .profile-detail-block h2 {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 15px;
  }

  .profile-detail-block table th,
  .profile-detail-block table td {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 70px;
    padding-left: 110px !important;
    padding-right: 10px !important;
  }

  .event td:before {
    width: 100px !important;
    text-align: center !important;
    background: #ebedee;
    top: 0;
    bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px !important;
    border-right: solid 1px #b3b3b3;
  }

  .td-apply::before {
    display: none !important;
  }

  .event .td-apply {
    padding: 0 !important;
    height: 60px !important;
  }

  .td-apply .btn {
    width: 100%;
    height: 100%;
    font-size: 25px;
    border-radius: 0 !important;
  }
}

@media (max-width: 320px) {
  .mobile-title {
    float: right;
    font-size: 12px;
  }
  .mobile-app-date {
    float: right;
    font-size: 10.1px;
  }
  .mobile-only-span {
    float: none;
    margin-right: 0px;
  }
  br.mobile-only {
    display: none;
  }
  .event-name {
    width: 120px;
  }
}
</style>
